import Schema from "../details/validation";
import { getColumnSize } from "modules/common/services/table/size-storage";
import { getFieldLabel } from "modules/common/services/form/fields";
import { fields } from "modules/dictionaries/work-types/models/work-type";
import { RowNumberColumn } from "modules/common/services/table/helpers";
import { ColDef } from "ag-grid-community";
export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName);

    const result: ColDef[] = [
        RowNumberColumn(false, ""),
        {
            headerName: getFieldLabel(fields.name, Schema, null),
            field: fields.name,
            width: columnSize(fields.name, 150),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.description, Schema, null),
            field: fields.description,
            width: columnSize(fields.description, 750),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.category, Schema, null),
            field: fields.category,
            width: columnSize(fields.category, 300),
            valueGetter: ({ data }) => data.workTypeCategory,
            sortable: true,
            resizable: true,
        },
    ];

    return result;
};
